import { Component, OnInit,ViewChild } from '@angular/core';
import { RequestService } from '../../../../services/request.service';
import { environment } from '../../../../environments/environment';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { HttpClient, HttpHeaders ,HttpParams} from '@angular/common/http'; 
import { Router, ActivatedRoute } from "@angular/router";
import { DataTableDirective} from 'angular-datatables';
import { from, Subject } from 'rxjs';
import { DatePipe } from '@angular/common';
@Component({
  selector: 'app-air-quality-report',
  templateUrl: './air-quality-report.component.html',
  styleUrls: ['./air-quality-report.component.scss']
})
export class AirQualityReportComponent implements OnInit {

  @ViewChild(DataTableDirective, {static: false})
	dtElement: DataTableDirective;
	dtOptions: any = {};
	// dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject();

  constructor(
    private request : RequestService,
    private http: HttpClient,
    private router: Router,
    private datePipe:DatePipe
  ) { }

  filterZoneList: any = [];
  filterWardList: any = [];
  filterZoneIds: any[] = [];
  filterWardIds: any[] = [];

  ngOnInit(): void {
    this.DevicesAirQuality();
    this.ViewZone("");
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
      processing: true,
      dom: 'Bfrtip',
        buttons: [
        {
          extend: 'csv',
          text:      '<i class="fa fa-file-text-o"></i>',
          titleAttr: 'Download as CSV',
          title: 'Device Master' 
        },
        {
          extend: 'excel',
          text:      '<i class="fa fa-file-excel-o"></i>',
          titleAttr: 'Download as Excel',
          title: 'Device Master' 
        },
        {
          extend: 'pdf',
          text: '<i class="fa fa-file-pdf-o"></i>',
          titleAttr: 'Download as Pdf',
          title: 'Device Master' 
        }
      ]
    };
  }

  async ViewZone(zone_id: any) {
    try {
      const data: any = await this.request.post('/master/view_zone_master', { zone_no: zone_id });
      const zones = [];
      if (data && data.result) {
        for (let item of data.result) {
          zones.push({
            id: item.zone_id,
            zone_name: item.zone_no + " (" + item.zone_name + ")"
          });
        }
      }
      this.filterZoneList = zones;
    } catch (error) {
      console.error(error);
    }
  }

  async onFilterZoneChange(event: any) {
    this.filterWardList = [];
    this.filterWardIds = [];
    if (!this.filterZoneIds || this.filterZoneIds.length === 0) {
      this.applyFilter();
      return;
    }
    for (let zoneId of this.filterZoneIds) {
      await this.LoadWardsForFilter(zoneId);
    }
    this.applyFilter();
  }

  async LoadWardsForFilter(zone_id: any) {
    try {
      const data: any = await this.request.post('/master/view_ward_master_by_zone', { zone_no: zone_id });
      if (data && data.result) {
        for (let ward of data.result) {
          const exists = this.filterWardList.some((x: any) => x.id === ward.ward_id);
          if (!exists) {
            this.filterWardList.push({
              id: ward.ward_id,
              ward_name: ward.ward_no + " (" + ward.ward_name + ")"
            });
          }
        }
      }
      this.filterWardList = [...this.filterWardList];
    } catch (error) {
      console.error(error);
    }
  }

  onFilterWardChange(event: any) {
    this.applyFilter();
  }

  applyFilter() {
    let filtered = [...this.deviceData];
    if (this.filterZoneIds && this.filterZoneIds.length > 0) {
      filtered = filtered.filter(item => 
        this.filterZoneIds.includes(item.zone_id) || 
        this.filterZoneIds.includes(Number(item.zone_id)) || 
        this.filterZoneIds.includes(String(item.zone_id))
      );
    }
    if (this.filterWardIds && this.filterWardIds.length > 0) {
      filtered = filtered.filter(item => 
        this.filterWardIds.includes(item.ward_id) || 
        this.filterWardIds.includes(Number(item.ward_id)) || 
        this.filterWardIds.includes(String(item.ward_id))
      );
    }
    this.rowData = filtered.sort((a, b) => {
      const dateA = this.parseDate(a.log_date_time);
      const dateB = this.parseDate(b.log_date_time);
      return dateB.getTime() - dateA.getTime();
    });
    this.rerenderTable();
  }

  resetFilter() {
    this.filterZoneIds = [];
    this.filterWardIds = [];
    this.filterWardList = [];
    this.rowData = [...this.deviceData].sort((a, b) => {
      const dateA = this.parseDate(a.log_date_time);
      const dateB = this.parseDate(b.log_date_time);
      return dateB.getTime() - dateA.getTime();
    });
    this.rerenderTable();
  }

  rerenderTable(): void {
    if (this.dtElement && this.dtElement.dtInstance) {
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.destroy();
        this.dtTrigger.next();
      });
    } else {
      this.dtTrigger.next();
    }
  }

  ShowReport(){
    let dateTime = this.datePipe.transform($("#dateTime").val(),"yyyy-MM-dd");
    let fromDate = dateTime+" 00:00:00";
    let toDate = dateTime+" 23:59:59";
    console.log(fromDate+" :: "+toDate);
  }
  rowData;
  deviceData=[];
  isLoading=false;
  async DevicesAirQuality(){
    try {
      this.isLoading=true;
      this.deviceData=[];
      const requestData = {};
      this.dtTrigger=new Subject<any>();
      const data: any = await this.request.post('/dashboard/view_toilet_feedback_log_data', requestData);
      this.dtTrigger.next();
      for (let objKey of Object.keys(data.result)) {
        let dataObj = data.result[objKey];
        this.deviceData.push(dataObj);
      }
      this.rowData = this.deviceData;
      // console.log(this.rowData);
      this.rowData = [...this.deviceData].sort((a, b) => {
        const dateA = this.parseDate(a.log_date_time);
        const dateB = this.parseDate(b.log_date_time);

        return dateB.getTime() - dateA.getTime();
      });

      this.isLoading=false;
    } catch (error) {}
  }

  parseDate(dateStr: string): Date {
    const [datePart, timePart] = dateStr.split(' ');
    const [day, month, year] = datePart.split('-').map(Number);
    const [hours, minutes, seconds] = timePart.split(':').map(Number);

    return new Date(year, month - 1, day, hours, minutes, seconds);
  }

}
